<template>
  <div class="animated fadeIn">
    <component-header
      title="View Tax Code"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push({ name: 'Taxcode' })"
    />
    <b-card>
      <b-row>
        <b-col sm="6">
          <b-form-group label="Tax Code" label-for="Tax Code" :label-cols="3">
            <b-form-input
              disabled
              type="text"
              id="taxcode"
              placeholder="Topic"
              v-model="details.taxCode"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Country" label-for="Country" :label-cols="3">
            <b-form-input
              type="text"
              id="country"
              placeholder="Country"
              disabled
              v-model="details.country"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="Start Date"
            label-for="Start Date"
            :label-cols="3"
          >
            <b-form-input
              type="text"
              id="startdate"
              placeholder="Start Date"
              disabled
              v-model="details.startDate"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="End Date" label-for="End Date" :label-cols="3">
            <b-form-input
              type="text"
              id="enddate"
              placeholder="End Date"
              disabled
              v-model="details.endDate"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <div
        v-if="
          details &&
          details.restData &&
          details.restData.details &&
          details.restData.details.length
        "
      >
        <div v-for="(data, idx) in details.restData.details" :key="idx">
          <div v-for="(Taxdata, id) in data.taxLines" :key="id">
            <b-row>
              <b-col md="6">
                <label for="start-date">Tax Line Name</label>
                <b-input
                  id="start-date"
                  type="text"
                  readonly
                  v-model="Taxdata.taxLineName"
                ></b-input>
              </b-col>
              <b-row
                v-for="(Tax, i) in Taxdata.taxRates"
                :key="i"
                class="mt-0 ml-0 mr-0"
              >
                <b-col md="12">
                  <label for="start-date">Tax Rate</label>
                  <b-input
                    id="start-date"
                    type="text"
                    readonly
                    v-model="Tax.tax"
                  ></b-input>
                </b-col>
              </b-row>
            </b-row>
            <b-row v-for="(Tax, i) in Taxdata.taxRates" :key="i">
              <b-col md="6" class="mt-2">
                <label for="start-date">Tax Line Type</label>
                <b-input
                  id="start-date"
                  type="text"
                  readonly
                  v-model="Tax.rateType"
                ></b-input>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";

export default {
  name: "ViewTaxCode",
  components: {
    ebButton,
    cInput,
    ebSelect,
    ComponentHeader,
  },

  data: () => {
    return { details: {} };
  },
  // props: {
  //   details: {
  //     type: Object,
  //     required: true
  //   }
  // },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  mounted() {
    this.details = { ...this.$route.params.data };
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
